import { BaseModel } from '@core/data-access';

export interface ContentBuilderContentInterface {
  html: string;
  css: string[];
  printOptions: any;
  annotations?: any[];
}

export class ContentBuilderContentModel extends BaseModel implements ContentBuilderContentInterface {
  html!: string;
  css!: string[];
  printOptions!: any;
  annotations?: any[];
}
